import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery';
import Config from '../../../base/pride.config';

export default class OverlayContainer extends ComponentBasePrototype {
  build() {
    this.hash = `#${this.data.overlayId}`;
    this.addHashChangeEventListener();
    this.setCloseButtonHandler();
    this.closeModalOnSmokeClick();
    this.closeModalOnTabClick();
    this.closeModalOnEscapeKey();
    this.setModalState();
    this.openSlidingModalOnButtonClick();

    this.isSlidingModal = this.node.hasClass('overlay-container--sliding');
    this.modal = this.node.find('.overlay-container__modal');

    if (this.isSlidingModal && !Config.get('editorMode')) {
      this.repositionModal();
      this.positionSlidingModalOnResize();
    }

    return true;
  }

  openSlidingModalOnButtonClick() {
    this.node.find('.overlay-container__slide-open').on('click', () => {
      window.location.hash = this.hash;
    });
  }

  addHashChangeEventListener() {
    window.addEventListener('hashchange', this.setModalState.bind(this));
  }

  setModalState() {
    const thisModalIsRequested = window.location.hash === this.hash;

    if (thisModalIsRequested) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }

  openModal() {
    // Resetting display for focusable elements inside the modal
    this.node.find('button:not(.overlay-container__slide-open), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      .css('display', '');

    // Saving the element that triggered the modal to open so as to bring the focus back to it when the modal is closed in the closeModal method.
    this.triggerElement = document.activeElement;

    // Setting focus trap inside the modal
    setTimeout(() => {
      let focusableElements = this.modal.find('button:not(.overlay-container__close-button), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
      let firstFocusableElement = focusableElements[0];
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      } else {
        this.modal.find('.overlay-container__close-button').focus();
      }
      this.trapFocus();
    }, 0);

    // To prevent background scroll completely we need to set the no-scroll class to html and body.
    // This class contains styling that scrolls the page to the top.
    // So we save the scroll position when opening the modal and reposition the page when closing.
    this.saveCurrentScrollPosition();
    this.preventBackgroundScroll();
    this.node.addClass('overlay-container--open');
  }

  closeModal() {
    this.scrollToTopOfModal();
    this.node.removeClass('overlay-container--open');
    this.enableBackgroundScroll();
    // We have to resume scroll position after enabling scroll, it won't work the other way around.
    this.resumePreviousScrollPosition();
    this.removeTrapFocus();
    


    let slideOpenButton = this.node.find('.overlay-container__slide-open');

    // Returning focus to the element that triggered the modal to open
    if (this.triggerElement) {
      this.triggerElement.focus();
    }
    // Setting display to none for focusable elements inside the modal, excluding the slideOpenButton element of the modal itself
    this.node.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      .not(slideOpenButton)
      .css('display', 'none'); // setting display to none all modal focusable elements except the slideOpenButton especially done for sliding modal
  }

  trapFocus() {
    let focusableElements = this.modal.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];

    $(document).on('keydown', (event) => {
      if (!this.node.hasClass('overlay-container--open')) {
        return;
      }

      let isTabPressed = (event.key === 'Tab');

      if (!isTabPressed) {
        return;
      }

      if (event.shiftKey) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          event.preventDefault();
        }
      } else { // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          event.preventDefault();
        }
      }
    });
  }

  removeTrapFocus() {
    if (!this.modal) {
      return;
    }
    this.modal.off('keydown', this.focusTrapHandler);
  }

  saveCurrentScrollPosition() {
    this.scrollPosition = $(window).scrollTop();
  }

  resumePreviousScrollPosition() {
    if (this.scrollPosition) {
      $(window).scrollTop(this.scrollPosition);
    }
  }

  preventBackgroundScroll() {
    if (this.isSlidingModal) {
      // Preventing scroll is delayed slightly in case there are multiple modals..
      // so that the hashchange listener doesn't globally enable scrolling if one the modals happens to be open at page load time.
      setTimeout(() => {
        $('html, body').addClass('no-scroll');
      }, 200);
    }
  }

  enableBackgroundScroll() {
    if (this.isSlidingModal) {
      $('html, body').removeClass('no-scroll');
    }
  }

  scrollToTopOfModal() {
    const smokeOverlay = this.node.find('.overlay-container__smoke')[0];
    smokeOverlay.scrollTop = 0;
  }

  setCloseButtonHandler() {
    this.node.find('.overlay-container__close-button').on('click', (event) => {
      event.preventDefault(); // Preventing the default POST request
      this.closeModal();
      this.removeHash();
    });
  }

  closeModalOnSmokeClick() {
    this.node.find('.overlay-container__smoke').on('click', () => {
      this.closeModal();
      this.removeHash();
    });
  }

  closeModalOnTabClick() {
    this.node.find('.overlay-container__slide-close').on('click', () => {
      this.closeModal();
      this.removeHash();
    });
  }

  // Note: This does not trigger the hashchange event
  removeHash() {
    history.pushState(
      '',
      document.title,
      `${window.location.pathname}${window.location.search}`,
    );
  }

  closeModalOnEscapeKey() {
    $(document).on('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeModal();
        this.removeHash();
      }
    });
  }

  positionSlidingModalOnResize() {
    $(window).on('resize', () => {
      this.repositionModal();
    });
  }

  repositionModal() {
    const modalWidth = this.modal.outerWidth();
    this.modal.css('right', -modalWidth);
  }
}


